'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
const getI18nPrefix = enabled => enabled ? 'enabled' : 'disabled';
const i18nKey = key => `ContentComponents.cmv2.fields.form.marketingContactsWarning.${key}`;
const MarketingContactsWarning = ({
  enabled = false,
  useEditor = false,
  openFormFn = () => {}
}) => {
  const type = enabled ? 'success' : 'warning';
  return /*#__PURE__*/_jsx(UIAlert, {
    type: type,
    className: "m-bottom-4",
    "data-is-enabled": enabled,
    children: useEditor ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: i18nKey(`${getI18nPrefix(enabled)}.goToEditor_jsx`),
      options: {
        external: true,
        onClick: openFormFn
      },
      elements: {
        Link: UILink
      }
    }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: i18nKey(`${getI18nPrefix(enabled)}.editInline`)
    })
  });
};
export default MarketingContactsWarning;